import React from 'react'
import { useHistory } from 'react-router-dom'

const useURLQueryParams = () => {
    const history = useHistory()
    const search = window.location.search

    const changeParams = (rerender: boolean) => (names: string[], values: string[]) => {
        const searchParams = names.map((key, index) => `${key}=${values[index] || ''}`)
        // We update the react router history causing rerender of routes
        // This is best practice in most cases but might cause some bad UX
        // For instance, query param changes while submitting a form would cause loss of the inputs
        if (rerender) {
            history.push({
                pathname: history.location.pathname,
                search: '?' + searchParams.join('&')
            })
            return
        }
        const newURL = window.location.pathname + '?' + searchParams.join('&')
        window.history.pushState({ path: newURL }, '', newURL)
    }

    const queryURLParams = React.useMemo(() => {
        const params = Array.from(new URLSearchParams(search).entries())
        let formattedParams: Record<string, string> = {}
        params.forEach((param) => {
            formattedParams[param[0]] = param[1]
        })
        return formattedParams
    }, [search])

    return [queryURLParams, changeParams(false), changeParams(true)] as [
        Record<string, any>,
        (names: string[], values: string[]) => void,
        (names: string[], values: string[]) => void
    ]
}

export default useURLQueryParams
